export const faqData = [
  {
    id: 1,
    question:
      "Can I calculate the EMI for multiple loan types using the ICICI Calculator?",
    answer:
      "Yes, the ICICI Bank EMI Calculator allows you to calculate the EMI for car loans, home loans, personal loans, and education loans. Simply select the loan type you want to calculate.",
  },
  {
    id: 2,
    question:
      "	Does the EMI Calculator include processing fees and other hidden charges?",
    answer:
      "The calculator provides an estimate based on the loan amount and interest rate. However, it’s always a good idea to verify the processing fees and other charges with ICICI Bank, as they can impact your total loan cost.",
  },
  {
    id: 3,
    question:
      "	Can I adjust the tenure or loan amount in the calculator to see how changes affect my EMI?",
    answer:
      "Yes, the ICICI Car Loan EMI Calculator allows you to adjust both the loan amount and loan tenure, helping you explore how different combinations affect your monthly EMI and total repayment.",
  },
];
